export class Row {
    public data: any;
    public form_data!: {
        data: any[];
        rows: [{
            data: {};
            fields: [{}];
        }];
    };

    constructor(
        // private Utils:Utils
    ) { }

    public init() {
        this.data = {
            pager: {
                next: 0,
                previous: 0
            }
        };

        this.form_data = {
            data: [],
            rows: [{
                data: {},
                fields: [{}]
            }]
        };
    }

    public setData(data: any): void {
        for (var key in data) {
            if (this.data[key] != undefined) {
                this.data[key] = data[key];
            }
        }
    }

    public getData(levels?: string | string[]): any {
        if (levels) {
            let return_data: any = {};

            for (let key in this.data) {
                if (levels.indexOf(key) > -1) {
                    return_data[key] = this.data[key];
                }
            }

            return return_data;
        }

        return this.data;
    }

    // public getDataValues(levels?: string): any {
    //     let return_data: any = {};
    //     let levels_array: any = {};

    //     (levels) ? levels_array = levels.split(",") : null;

    //     for (let key in this.data) {
    //         if (levels && levels_array.includes(key)) {
    //             for (let value in this.data[key]) {
    //                 (!return_data[value]) ? return_data[value] = this.data[key][value] : return_data[key + "-" + value] = this.data[key][value];
    //             }
    //         } else {
    //             for (let value in this.data[key]) {
    //                 (!return_data[value]) ? return_data[value] = this.data[key][value] : return_data[key + "-" + value] = this.data[key][value];
    //             }
    //         }
    //     }

    //     return return_data;
    // }

    public getDataValues(levels?: string): any {
        if (!levels) {
            return structuredClone(this.data);
        }

        const return_data: any = {};
        const level_keys = levels.split(',').map(level => level.trim());

        for (const level of level_keys) {
            const level_data = this.data?.[level];

            if (!level_data || typeof level_data !== 'object') continue;

            for (const key of Object.keys(level_data)) {
                if (!(key in return_data)) {
                    return_data[key] = level_data[key];
                }
            }
        }

        return return_data;
    }

    // public getDataValues(levels?: string): any {
    //     if (!levels) {
    //         return structuredClone(this.data);
    //     }

    //     const return_data: any = {};
    //     const level_keys = levels.split(',').map(l => l.trim());

    //     for (const level of level_keys) {
    //         if (this.data[level] && typeof this.data[level] === 'object') {
    //             return_data[level] = structuredClone(this.data[level]);
    //         }
    //     }

    //     if (level_keys.length === 1) {
    //         return return_data[level_keys[0]] ?? {};
    //     }

    //     return return_data;
    // }

    public getValue(level: string, param: string): any {
        if (this.data[level][param].indexOf() > -1) {
            return this.data[level][param];
        }
    }

    public static async hasPermission(Utils:any, module: string, permission: string) {
        const data = await Utils.getInStorage("user_permission");
        let return_data = false;

        if (data.length != undefined && data.length > 0) {
            for (let row of data) {
                if (row.module == module && row.permission == permission && row.active == 1 && row.deleted == 1) {
                    return_data = true;
                    break;
                }
            }
        }

        return return_data;
    }

    public static async addPermission(Utils:any, module: string, permission: string) {
        let data = await Utils.getInStorage("user_permission");
        data.push({ module: module, permission: permission, active: 1, deleted: 1 });
        await Utils.setInStorage("user_permission", data);

        return true;
    }

    public static async removePermission(Utils:any, module: any, permission: any) {
        let data = await Utils.getInStorage("user_permission");

        if (data.length != undefined && data.length > 0) {
            for (let key in data) {
                let row = data[key];

                if (row.module == module && row.permission == permission && row.active == 1) {
                    data[key].active = 0;
                    data[key].deleted = 0;
                    await Utils.setInStorage("user_permission", data);
                    break;
                }
            }
        }

        return true;
    }

    public static async getPermissionByModule(Utils:any, module: string) {
        const data = await Utils.getInStorage("user_permission");
        let return_data: any = [];

        if (data.length != undefined && data.length > 0) {
            for (let row of data) {
                if (row.module == module) {
                    return_data.push(row);
                }
            }
        }

        return return_data;
    }

    public static searchPermissionInData(data: string | any[], module: any, permission: any) {
        let hasPermission = false;

        if (data.length != undefined && data.length > 0) {
            for (let row of data) {
                if (row.module == module && row.permission == permission && row.active == true) {
                    hasPermission = true;
                    break;
                }
            }
        }

        return hasPermission;
    }
}
